export default __webpack_public_path__ + "static/media/Ballroll_00291.339aa62d.png";